module.exports = __webpack_public_path__ + "static/media/icicles.7628454a.svg";